// extracted by mini-css-extract-plugin
export default {"formInputBlock":"FormInputBlock_formInputBlock__7Oo8G"};